import options from './on-enter.directive';

export default {
    selector: 'onEnter',
    options
};



// WEBPACK FOOTER //
// ./app/common/on-enter/index.js